import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import PropTypes from 'prop-types';

const NumberField = forwardRef((props, ref) => {
    const { onChange, ...other} = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange(values.floatValue);
        }}
      />
    );
  }
);

NumberField.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default NumberField;